import { SITE } from "@/config/site";
import { useSeo } from "@/hooks/useSeo";
import { ErrorBoundary } from "@/components/layout/ErrorBoundary";
import { Hero } from "@/sections/home/Hero";
import { LiveExperience } from "@/sections/home/LiveExperience";
import { PropheticDeclaration } from "@/sections/home/PropheticDeclaration";
import { Welcome } from "@/sections/home/Welcome";
import { Pathways } from "@/sections/home/Pathways";
import { Tribe } from "@/sections/home/Tribe";
import { LatestMessage } from "@/sections/home/LatestMessage";
import { Events } from "@/sections/home/Events";
import { Devotional } from "@/sections/home/Devotional";
import { FindChurch } from "@/sections/home/FindChurch";
import { CareGroups } from "@/sections/home/CareGroups";
import { Expressions } from "@/sections/home/Expressions";
import { Testimonies } from "@/sections/home/Testimonies";
import { Word } from "@/sections/home/Word";
import { Give } from "@/sections/home/Give";
import { FinalCta } from "@/sections/home/FinalCta";
import type { ComponentType } from "react";

/** Each section is isolated: one failing section never breaks the homepage. */
const SECTIONS: [string, ComponentType][] = [
  ["live", LiveExperience],
  ["welcome", Welcome],
  ["declaration", PropheticDeclaration],
  ["pathways", Pathways],
  ["latest", LatestMessage],
  ["tribe", Tribe],
  ["devotional", Devotional],
  ["events", Events],
  ["find", FindChurch],
  ["care-groups", CareGroups],
  ["expressions", Expressions],
  ["testimonies", Testimonies],
  ["word", Word],
  ["give", Give],
  ["final", FinalCta],
];

export default function HomePage() {
  useSeo({
    path: "/",
    description: `${SITE.tagline}. Miracle Assembly is a Spirit and Word church led by ${SITE.pastor} in Benin City. Watch live, hear the prophetic declaration, read today's devotional and find a care group.`,
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: SITE.name,
      url: "https://miracleassembly.org/",
    },
  });
  return (
    <>
      <Hero />
      {SECTIONS.map(([key, Section]) => (
        <ErrorBoundary key={key} label={key} fallback={null}>
          <Section />
        </ErrorBoundary>
      ))}
    </>
  );
}
